import styled from '@emotion/styled';

export const StatContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
export const StatTitle = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 24px;
`;